import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Create, Add, BeenhereRounded, Visibility } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { Link } from 'react-router-dom';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsGetAll } from 'services/WService.js';

//modal
import Modal from './Modal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
});

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 180 },
  { Header: 'Cuenta', accessor: 'account' },
  { Header: 'Descripción', accessor: 'description' },
  { Header: 'Sincronización SAP', accessor: 'sapSync' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

export default WithApp(function AccountList(props) {
  const classes = useStyles();

  const [openModal, setOpenModal] = useState(false);
  const [notify, showNotify] = useToasty();
  const [accounts, setAccounts] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  async function listAccounts() {
    setDataLoading(true);
    let response = await wsGetAll('pymt/account-sap');
    setDataLoading(false);
    if (response.success) setAccounts(response.data);
  }

  useEffect(() => {
    listAccounts();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <Modal open={openModal} setOpen={setOpenModal} showNotify={showNotify} reload={listAccounts} />

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.PYMT_ACCOUNTS_STORE}
              component={
                <CardIcon color={props.themeContext.buttonColor}>
                  <BeenhereRounded style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpenModal(true)}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Listado de cuentas sap{dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="Cuentas"
              defaultWidth={1000}
              columns={columns}
              data={accounts.map((item, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.PYMT_ACCOUNTS_DELETED}>
                        <ButtonDelete entity="pymt/account-sap" id={item.id} reload={listAccounts} />
                      </AllowedGuard>
                    </div>
                  ),
                  account: item.AcctCode,
                  description: item.AcctName,
                  sapSync: item.SapSync == 'Y' ? 'Sí' : 'No',
                  actions: ''
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
